<mat-card>
    <mat-card-header>
        <mat-card-title>Occupancy Data</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <p>Average Occupancy: {{ averageOccupancy }}%</p>

        <mat-form-field appearance="outline">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date">
                <input matEndDate placeholder="End date">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker" [(ngModel)]="startDate"></mat-datepicker-toggle>
            <mat-date-range-picker #picker [(ngModel)]="endDate"></mat-date-range-picker>
        </mat-form-field>
        <button mat-raised-button (click)="search()">Filter</button>

<!--        <table mat-table [dataSource]="rankings | keyvalue">-->
<!--            <ng-container matColumnDef="dateString">-->
<!--                <th mat-header-cell *matHeaderCellDef> Date </th>-->
<!--                <td mat-cell *matCellDef="let element"> {{ element.key }} </td>-->
<!--            </ng-container>-->

<!--            <ng-container matColumnDef="centerName">-->
<!--                <th mat-header-cell *matHeaderCellDef> Centre Name </th>-->
<!--                <td mat-cell *matCellDef="let element"> {{ element.value.centerName }} </td>-->
<!--            </ng-container>-->

<!--            <ng-container matColumnDef="Occupancy">-->
<!--                <th mat-header-cell *matHeaderCellDef> Occupancy (%) </th>-->
<!--                <td mat-cell *matCellDef="let element"> {{ element.value.Occupancy }} </td>-->
<!--            </ng-container>-->

<!--            <ng-container matColumnDef="totalRooms">-->
<!--                <th mat-header-cell *matHeaderCellDef> Total Rooms </th>-->
<!--                <td mat-cell *matCellDef="let element"> {{ element.value.totalRooms }} </td>-->
<!--            </ng-container>-->

<!--            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>-->
<!--            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
<!--        </table>-->
    </mat-card-content>
</mat-card>
